import {
    LIST_GEOFENCE,
    CREATE_GEOFENCE,
    UPDATE_GEOFENCE,
    DELETE_GEOFENCE,
    CREATE_GEOFENCE_DETAIL,
    GET_GEOFENCE_DETAIL,
    GET_GEOFENCE, UPDATE_GEOFENCE_DETAIL, GET_VEHICLE_GEOFENCE, GET_VEHICLE_FLEETGROUP, UPDATE_VEHICLE_GEOFENCE,
    LIST_GEOFENCE_CATEGORY,
    DETAIL_GEOFENCE_CATEGORY,
    CREATE_GEOFENCE_CATEGORY,
    UPDATE_GEOFENCE_CATEGORY,
    DELETE_GEOFENCE_CATEGORY

} from "../constant";
import axios from 'axios';
import * as REPO from '../helper/main'

const localKey = 'token';

export const getListGeofence = () => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(LIST_GEOFENCE, config_token);
};
export const getOneGeofence = id => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(GET_GEOFENCE + id, config_token);
};

export const postGeofence = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_GEOFENCE, data, config_token);
};

export const updateGeofence = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_GEOFENCE + id, data, config_token);
};

export const deleteGeofence = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.delete(DELETE_GEOFENCE + id, config_token);
};

// GEOFENCE DETAIL

export const postGeofenceDetail = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_GEOFENCE_DETAIL, data, config_token);
};

export const updateGeofenceDetail = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_GEOFENCE_DETAIL + id, data, config_token);
};

export const getGeofenceDetail = id => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(GET_GEOFENCE_DETAIL + id, config_token);
};


export const getListVehicleGeofence = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(GET_VEHICLE_GEOFENCE + id, config_token);
};
export const getListVehicleFleetGroup = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(GET_VEHICLE_FLEETGROUP + id, config_token);
};


export const updateGeofencePairing = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_VEHICLE_GEOFENCE + id, data, config_token);
};


// Geofence Category

export const getListGeofenceCategory = (body) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };

    let param = REPO.bikinParam(body)
    return axios.get(LIST_GEOFENCE_CATEGORY + param, config_token);
}

export const getOneGeofenceCategory = id => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(DETAIL_GEOFENCE_CATEGORY + id, config_token);
};

export const postGeofenceCategory = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_GEOFENCE_CATEGORY, data, config_token);
}

export const updateGeofenceCategory = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_GEOFENCE_CATEGORY + id, data, config_token);
}

export const deleteGeofenceCategory = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.delete(DELETE_GEOFENCE_CATEGORY + id, config_token);
}